import { Component } from "react";
import Card from "@/components/card";
import Title from "@/components/title";
import Button from "@/components/button";
import click from "@/images/click.svg";
import DiscoverCourse from "@/views/discover/discoverCourse";
import AzureRequest from "@/services/request";

class Discover extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalCourses: 0,
      courses: [],
      error: false
    };
    this.courses = [];
    this.request = new AzureRequest();
    this.refreshCourses = this.refreshCourses.bind(this);
  }

  async componentDidMount() {
    this.request.post({
      top: 0,
      count: true,
    }).then((response) => {
      this.setState(
        {totalCourses: response['@odata.count']},
        this.refreshCourses
      );
    }).catch((error) => {
      this.setState({error});
      console.log(error);
    });
  }

  /**
   * select 4 random courses
   * @returns Array
   */
  refreshCourses() {
    this.setState({courses: []});
    let indexes = []
    for (let i = 0; i < 4; i++) {
      let courseIndex = 0;
      let indexIsNotUnique = true;
      while (indexIsNotUnique) {
        courseIndex = Math.floor(Math.random() * this.state.totalCourses);
        // eslint-disable-next-line
        indexIsNotUnique = indexes.find((elem) => elem === courseIndex);
      }
      indexes.push(courseIndex);
      this.request.post({
        top: 1,
        skip: courseIndex
      }).then((response) => {
        console.log(response.value);
        this.setState({courses: [...this.state.courses, ...response.value]});
      }).catch((error) => {
        this.setState({error});
        console.log(error);
      });
    }
  }

  render() { 
    return (
      <section className="relative z-10 container lg:w-3/4 w-11/12 md:-mt-32 -mt-8 mb-20 mx-auto flex flex-col items-center">
        <Card
          width="1"
          height="1"
          justify="center"
          background="gray-dark"
          textColor="white"
          image="telescope"
          imagePosition="right-bottom"
        >
          <Title
            title="Découverte des formations"
            subtitle="Je découvre au hasard des domaines professionnels et des formations"
            level="3"
            justify="center"
          />
          <div className="relative my-6 grid md:grid-cols-6 sm:grid-cols-3 grid-cols-2 gap-6 mx-auto grid-flow-row-dense">
            <img src={click} alt="Cliquer sur une étoile" className="sm:col-span-1 sm:row-span-2 md:col-span-1 md:row-span-1 mx-auto"/>
            {this.state.error ? 
              <div>Impossible de charger les formations, veuillez réessayer</div>
            :
              this.state.courses.map((course, index) => (
                <div>
                  <DiscoverCourse index={index} key={course.AzureSearch_DocumentKey} course={course} />
                </div>
              ))
            }
          </div>
          <div className="my-4">
            <Button
              label="Recommencer"
              padding="4"
              onButtonClick={this.refreshCourses}
            />
          </div>
        </Card>
      </section>
    );
  }
}
 
export default Discover;